import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FormReviewDashboardService {

  constructor(private http: HttpClient) {}

  getViewForDropdown(pdfEngineUrl: string, taxYear: string, scenario: string, jcdKey: number, leType: string, srcSystemFlag: string, category: string): Observable<any> {
    if (leType === 'CONSOL') leType = 'CON';
    const url = `${pdfEngineUrl}/getViewForDropdown?taxYear=${taxYear}&scenario=${scenario}&jcdKey=${jcdKey}&leType=${leType}&src_system_flag=${srcSystemFlag}&business_type=${category}`;
    return this.http.post<any>(url, {}, { withCredentials: true }).pipe(map((res: any) => res.data || res));
  }

  getTaxForms(pdfEngineUrl: string, taxYear: string, scenario: string, jcdKey: number, selectedView: string, rpPeriod: string, leType: string, cdrNo: string, srcSystemFlag: string, category: string): Observable<any> {
    if (srcSystemFlag === 'F' && leType === 'PSHIP') leType = 'HO';
    const url = `${pdfEngineUrl}/getTaxForms?taxYears=${taxYear}&scenario=${scenario}&jcdKey=${jcdKey}&selectedView=${selectedView}&cdrNo=${cdrNo}&reportingPeriod=${rpPeriod}&leType=${leType}&src_system_flag=${srcSystemFlag}&business_type=${category}&entity_type=&cgkey=`;
    return this.http.post<any>(url, {}, { withCredentials: true }).pipe(map((res: any) => res.data || res));
  }
}
